<template>
  <div class="overflow-x justify-content-center mt-5">
      <div class=" p-list-representation-table-main">
        <table class="table table-bordered p-table">
            <thead>
              <tr>
                <th>نام مجموعه </th>
                <th >نام سالن</th>
                <th >نام صاحب</th>
                <th >مانده حساب</th>
                <th >موبایل صاحب</th>
                <th >موبایل مدیر</th>
                <th >شماره سالن</th>
                <th >استان/شهر</th>
                <th >گزینه ها</th>

              </tr>
            </thead>
            <tbody>
              <tr v-for="data in tableData" :key="data.id">
                <th scope="row">{{data.club.title}}</th>
                <td>{{data.name}}</td>
                <td>{{data.club.name}} {{data.club.family}}</td>
                <td>{{data.addCamaPrice}}+</td>
                <td>{{data.club.mobile}}</td>
                <td>{{data.phone}}</td>
                <td>{{data.phone}}</td>
                <td>{{data.club.location_text}}</td>
                <td>
                    <div class="d-flex justify-content-end flex-column col-9 mr-auto ml-auto">
                            <div class="row w-100 mb-2 justify-content-center flex-column">
                              <button @click="managementSalon(data)" type="button" class="btn btn-primary btn-blue btn-sm ml-2 btn-table mb-2 w-100">
                                مدیرت سانس ها
                              </button>
                              <button @click="changeRouteSalonEdit(data)" type="button" class="btn btn-primary btn-blue btn-sm btn-table w-100 mb-2">
                                ویرایش سالن ها
                              </button>
                              <button @click="modalShowEntryPay(data)" type="button" class="btn btn-primary btn-blue btn-sm btn-table w-100">
                                پرداخت
                              </button>
                            </div>
                            <div class="row w-100 mb-2 justify-content-center flex-column">
                              <button @click="changeRouteManageComment(data)"  type="button" class="btn btn-primary btn-blue btn-sm ml-2 btn-table mb-2 w-100">
                                مدیرت نظرات
                              </button>
                              <button @click="managementPorsant(data)" type="button" class="btn btn-primary btn-blue btn-sm  btn-table w-100">
                                مدیریت پورسانت و جنسی
                              </button>
                            </div>

                    </div>
                </td>

              </tr>

            </tbody>
          </table>
          <div class="d-flex justify-content-center p-table">
            <pagination v-model="valuePage" :per-page="20" :records="500" @paginate="changePage"/>
          </div>
      </div>

  </div>
</template>

<script>
import addCama from '../../modules/addCama.js'


export default {
    name: 'tableContent',
    props: {
      page      : { type: Number, default: 0 },
      tableData : { type: [Object, Array], default: [] },
    },

    data() {
      return {
        valuePage : 1,
      }
    },

    computed: {

    },

    mounted () {
      this.valuePage = this.page;
    },

    watch: {
      page(data){
        this.valuePage = this.page;
      },
    },

    methods: {
      changePage(data){
        this.$emit("paganationChangePage",data);
      },

      modalShowEntryPay(data){
        this.$emit("modalShowEntryPay",data);
      },

      changeRouteSalonEdit(data){
        localStorage.setItem("hallSingle", JSON.stringify(data));
        this.$router.push({path:'salon-edit/1'})
      },

      managementSalon(data){
        localStorage.setItem("hallSingle", JSON.stringify(data));
        this.$router.push({name:'managementTodaySalon' , params:{id:data.id} })
      },

      managementPorsant(data){
        this.$router.push({name:'managementCommissionAndGender' , params:{id:data.id} , query:{name:data.name , nameFamilySalonDar:data.club.name + ' ' + data.club.family} })
      },

      changeRouteManageComment(data){
        this.$router.push({name:'commentSalons' })
      },

    },

}
</script>
